<template lang="html">
  <div class="commentP" @click="toLookEvaluate">
    <div class="commentPersonItem">
      <div class="jxpjTag" v-if="comment.essence == 1"></div>
      <div class="userInfo">
        <div class="avatar">
          <img :src="comment.user.photo | avatarComment(90, 90)" alt="" />
        </div>
        <div class="userDes">
          <div class="userDesT">
            <div>
              <span class="userName">{{ name(comment.user.nickname) }}</span>
            </div>
            <span class="commentTime">{{
              dateTransformer(comment.created_at)
            }}</span>
          </div>
          <star
            size="medium"
            color="#FF8800"
            :canClick="false"
            :score="comment.score * 2"
          />
        </div>
      </div>
      <p class="sendYuesaoTag" v-if="comment.silkBannerNum > 0">
        赠送月嫂{{ comment.silkBannerNum }}面锦旗<i class="moreIcon" />
      </p>
      <p class="myCommentTag" v-else-if="comment.user.uid == cookieUid">
        我的评价
      </p>
      <div
        class="commentContent"
        :class="{ ommitContent: ommitContent }"
        v-if="comment.content"
      >
        {{ comment.content }}
      </div>
      <div
        class="commentImgs"
        v-if="comment.image_urls && comment.image_urls.length > 0"
      >
        <ul class="adviserParenting" v-if="type == 'adviser'">
          <li v-for="(image, index) in comment.image_urls.slice(0, 3)">
            <img
              :src="$$viewImageInCenter(image, 202, 202)"
              alt=""
              class="imgLi"
            />
          </li>
        </ul>
        <ul class="certifiedParenting" v-else-if="type == 'certified'">
          <li v-for="(image, index) in comment.image_urls.slice(0, 3)">
            <img
              :src="$$viewImageInCenter(image, 218, 218)"
              alt=""
              class="imgLi"
            />
          </li>
        </ul>
        <ul class="commentImgsUl" v-else>
          <li v-for="(image, index) in comment.image_urls.slice(0, 3)">
            <img
              :src="$$viewImageInCenter(image, 222, 222)"
              alt=""
              class="imgLi"
            />
          </li>
        </ul>
      </div>
      <div class="serviceTag">
        <span class="serviceType"
          >服务类型：{{
            comment.category ? comment.category : '育儿顾问服务'
          }}</span
        >
      </div>
      <div
        class="replay"
        v-if="showReply && comment && comment.replies && comment.replies[0]"
      >
        <p class="title">商家回复:</p>
        <div>{{ comment.replies[0].content }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import star from '@/components/common/star'
import { pushHref } from '@/plugins/jump'

export default {
  props: {
    comment: {
      type: Object,
      default() {
        return {}
      }
    },
    // 评论文案是否要控制行数
    ommitContent: {
      type: Boolean,
      default: true
    },
    // 是否显示回复
    showReply: {
      type: Boolean,
      default: true
    },
    type: {
      // 类型
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      limitReply: {
        isLong: false,
        isShow: false,
        isActive: false
      },
      cookieUid: this.$$cookie('uid') || ''
    }
  },
  methods: {
    toLookEvaluate() {
      // 新查看评价入口
      if (this.isCzjSpu) {
        const url = `//m.czj100.com/look/${this.comment.id}`
        location.href = `//app.czj100.com/webridge.html?url=${encodeURIComponent(
          url
        )}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie('skey')}`
        return
      }
      if (this.isRebuilding) {
        //产后恢复
        const skuid = this.selectedSku && this.selectedSku.skuId
        const popid = this.product && this.product.businessId
        this.newTrackClick(
          200011,
          undefined,
          `skuid: ${skuid || ''}, popid: ${popid || ''}`,
          121012367
        )
      }
      this.$$loading(true)
      window.scrollTo(0, 0)
      if (this.type == 'adviser' || this.type == 'certified') {
        this.$router.push({
          name: 'evaluate',
          query: {
            commentId: this.comment.id,
            workerCode: this.comment.object_id,
            categoryName: this.comment.category || '育儿顾问服务',
            ht: 'look'
          }
        })
      } else {
        this.$router.push({
          name: 'evaluate',
          query: {
            commentId: this.comment.id,
            ht: 'look'
          }
        })
      }
    },
    dateTransformer(timestamp) {
      timestamp = Math.round(timestamp)
      let mistiming = Math.round(new Date() / 1000) - timestamp
      let arrr = ['年', '个月', '星期', '天', '小时', '分钟', '秒']
      let arrn = [31536000, 2592000, 604800, 86400, 3600, 60, 1]
      for (let i = 0; i <= 6; i++) {
        let inm = Math.floor(mistiming / arrn[i])
        if (inm != 0) {
          return inm + arrr[i] + '前'
        }
      }
    },
    name(val) {
      if (val.length > 1) {
        return `${val.charAt(0)}***${val.charAt(val.length - 1)}`
      } else {
        return `${val.charAt(0)}***`
      }
    }
  },
  computed: {
    ...mapState(['previewImages', 'product', 'selectedSku', 'isCzjSpu']),
    isRebuilding() {
      // 产后恢复
      return (
        this.product &&
        this.product.spuId &&
        this.product.level4CategoryId &&
        parseInt(+this.product.level4CategoryId / 100) === 101121
      )
    }
  },

  components: {
    star
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.commentP {
  &:last-child {
    .commentPersonItem {
      &::after {
        border: 0;
      }
    }
  }
}

.jxpjTag {
  background: url('../../assets/images/comment/icon-jxpj.png') no-repeat center
    center;
  background-size: rem(90px) rem(90px);
  width: rem(90px);
  height: rem(90px);
  position: absolute;
  right: 0;
  top: rem(75px);
  z-index: 99;
}

.commentPersonItem {
  background: #fff;
  padding: rem(32px) 0 rem(12px);
  @include border(bottom);
  position: relative;

  .userInfo {
    display: flex;
    margin-bottom: rem(20px);

    .avatar {
      width: rem(64px);
      height: rem(64px);
      @include border(all, #f0f0f0, 1px, 50%);
      border-radius: 50%;
      margin-right: rem(12px);
      & > img {
        width: rem(64px);
        height: rem(64px);
        border-radius: 50%;
      }
    }
    .userDes {
      flex: 1;
      .userDesT {
        display: flex;
        justify-content: space-between;
        align-content: center;
        .userName {
          font-size: rem(28px);
          color: #262626;
          line-height: rem(34px);
          font-weight: 500;
          margin-right: rem(12px);
        }
        .userLevel {
          font-size: rem(18px);
          color: #f9f9f7;
          text-align: center;
          line-height: rem(20px);
          background-image: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
          border-radius: rem(14px);
          padding: 0 rem(12px);
        }
        .userLevelPlus {
          font-size: rem(18px);
          color: #f4efdb;
          text-align: center;
          line-height: rem(18px);
          background: #121212;
          border-radius: rem(14px);
          padding: 0 rem(12px);
        }
        .commentTime {
          font-size: rem(22px);
          color: #999999;
          line-height: rem(38px);
        }
      }
    }
  }

  .myCommentTag {
    font-size: rem(24px);
    color: #ff397e;
    line-height: rem(30px);
    margin-bottom: rem(12px);
  }

  .sendYuesaoTag {
    display: flex;
    align-items: center;
    font-size: rem(24px);
    color: #ff397e;
    line-height: rem(30px);
    margin-bottom: rem(12px);
    .moreIcon {
      margin-left: rem(10px);
      margin-top: rem(2px);
      width: rem(20px);
      height: rem(20px);
      background: url('../../assets/images/comment/icon_more_red.png') no-repeat
        center center;
      background-size: 100% 100%;
    }
  }

  .commentContent {
    font-size: rem(28px);
    color: #262626;
    line-height: rem(42px);
    margin-bottom: rem(20px);
  }
  .ommitContent {
    display: -webkit-box;
    word-break: break-all;
    text-align: left;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    max-height: rem(168px);
    overflow: hidden;
  }

  .commentImgs {
    .adviserParenting {
      display: flex;
      background: #fff;
      padding-bottom: rem(20px);
      & > li:nth-child(3n) {
        .imgLi {
          margin-right: 0;
        }
      }
      li {
        border-radius: rem(12px);
        > img {
          height: rem(202px);
          width: rem(202px);
          margin-right: rem(18px);
          background: #f5f5f5;
          border-radius: rem(12px);
        }
      }
    }
    .certifiedParenting {
      display: flex;
      background: #fff;
      padding-bottom: rem(20px);
      & > li:nth-child(3n) {
        .imgLi {
          margin-right: 0;
        }
      }
      li {
        border-radius: rem(12px);
        > img {
          height: rem(218px);
          width: rem(218px);
          margin-right: rem(18px);
          background: #f5f5f5;
          border-radius: rem(12px);
        }
      }
    }
    .commentImgsUl {
      display: flex;
      background: #fff;
      padding-bottom: rem(20px);
      & > li:nth-child(3n) {
        .imgLi {
          margin-right: 0;
        }
      }
      li {
        border-radius: rem(12px);
        > img {
          height: rem(222px);
          width: rem(222px);
          margin-right: rem(18px);
          background: #f5f5f5;
          border-radius: rem(12px);
        }
      }
    }
  }

  .serviceTag {
    font-size: rem(22px);
    color: #999999;
    line-height: rem(28px);
    margin-bottom: rem(18px);
    .serviceType {
      margin-right: rem(36px);
    }
  }

  .replay {
    background: #f9f9f9;
    border-radius: rem(16px);
    font-size: rem(26px);
    color: #808080;
    line-height: rem(38px);
    padding: rem(24px) rem(20px);
    margin-bottom: rem(18px);
    .title {
      font-size: rem(26px);
      color: #262626;
      line-height: rem(34px);
      font-weight: 500;
      margin-bottom: rem(8px);
    }
  }
}
</style>
